<template>
  <div class="member-info-container">
    <div v-if="!compact" class="member-row">
      <label for="account">会员账号：</label>
      <span id="account">{{ memberInfo.username || '--' }}</span>
    </div>
    <div v-if="!compact" class="member-row">
      <label for="username">会员id：</label>
      <span id="username">{{ memberInfo.uid || '--' }}</span>
    </div>
    <div class="member-row member-row-status">
      <el-switch
        text-color="#13ce66"
        size="mini"
        :value="memberInfo.status === 1"
        @change="handleStatusChange"
      ></el-switch>
      <el-button type="text" size="mini" class="history-btn" @click="openHistoryDialog">查看历史</el-button>
    </div>

    <el-dialog
      :title="statusDialogTitle"
      :visible.sync="statusDialogVisible"
      width="450px"
      :close-on-click-modal="false"
      append-to-body
      @closed="handleStatusDialogClosed"
    >
      <el-form ref="statusFormRef" :model="statusForm" :rules="statusFormRules" label-position="top">
        <el-form-item :label="statusDialogLabel" prop="remark">
          <el-input
            v-model="statusForm.remark"
            type="textarea"
            :rows="4"
            :placeholder="statusDialogPlaceholder"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="statusDialogVisible = false">取消</el-button>
        <el-button size="small" type="primary" :loading="statusSubmitting" @click="handleStatusConfirm">确认</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="账号状态历史记录"
      :visible.sync="historyDialogVisible"
      width="1200px"
      append-to-body
      class="page-dialog"
      destroy-on-close
      @opened="loadHistoryList"
    >
      <el-table :data="historyList" border stripe size="small" style="width: 100%" :max-height="400">
        <el-table-column :resizable="false" prop="id" label="序号" width="60" align="center"></el-table-column>
        <el-table-column :resizable="false" prop="after" label="操作状态" min-width="100"> </el-table-column>
        <el-table-column :resizable="false" prop="client_desc" label="备注" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.client_desc || '—' }}</template>
        </el-table-column>
        <el-table-column :resizable="false" prop="created_at" label="操作时间" min-width="140">
          <template slot-scope="scope">{{ formatTimestamp(scope.row.created_at) }}</template>
        </el-table-column>
        <el-table-column :resizable="false" prop="operator" label="操作人" min-width="120"></el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import { disableMember, enableMember, getMemberDisableEnableLog } from '@/api/member/account'
import { getGenderText } from '@/utils/common'
import { formatTimestamp } from '@/utils/time'

export default {
  name: 'MemberInfo',
  props: {
    memberInfo: {
      type: Object,
      default: () => ({}),
    },
    /** 仅展示状态开关与「历史」，用于会员列表表格紧凑布局 */
    compact: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      statusDialogVisible: false,
      statusSubmitting: false,
      pendingEnable: null,
      statusForm: {
        remark: '',
      },
      statusFormRules: {
        remark: [{ required: true, message: '请输入备注', trigger: 'blur' }],
      },
      historyDialogVisible: false,
      historyLoading: false,
      historyList: [],
    }
  },
  computed: {
    statusDialogTitle() {
      return this.pendingEnable ? '启用' : '禁用'
    },
    statusDialogLabel() {
      return this.pendingEnable ? '启用备注' : '禁用备注'
    },
    statusDialogPlaceholder() {
      return '请输入备注'
    },
  },
  methods: {
    getGenderText,
    formatTimestamp,
    openHistoryDialog() {
      this.historyDialogVisible = true
    },
    async loadHistoryList() {
      const uid = this.memberInfo?.uid
      if (!uid) return
      this.historyLoading = true
      try {
        const res = await getMemberDisableEnableLog({ uid })
        if (res.code === 0 && res.data?.list) {
          this.historyList = (res.data.list || []).sort(
            (a, b) => (b.id || b.created_at || 0) - (a.id || a.created_at || 0)
          )
        } else {
          this.historyList = []
        }
      } catch (e) {
        this.historyList = []
        this.$message.error('加载历史记录失败')
      } finally {
        this.historyLoading = false
      }
    },
    handleStatusChange(newVal) {
      this.pendingEnable = newVal
      this.statusDialogVisible = true
      // this.$emit('status-change')
    },
    handleStatusDialogClosed() {
      this.statusForm.remark = ''
      this.pendingEnable = null
      this.$refs.statusFormRef?.resetFields()
    },
    async handleStatusConfirm() {
      this.$refs.statusFormRef.validate(async valid => {
        if (!valid) return
        const uid = this.memberInfo?.uid
        if (!uid) {
          this.$message.error('缺少用户信息')
          return
        }
        this.statusSubmitting = true
        try {
          if (this.pendingEnable) {
            const res = await enableMember({ uid, enable_desc: this.statusForm.remark })
            if (res.code === 0) {
              this.$message.success('启用成功')
              this.statusDialogVisible = false
              console.log('status-change')
              this.$emit('status-change')
            } else {
              this.$message.error(res.msg || '启用失败')
            }
          } else {
            const res = await disableMember({ uid, disable_desc: this.statusForm.remark })
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.statusDialogVisible = false
              this.$emit('status-change')
            } else {
              this.$message.error(res.msg || '禁用失败')
            }
          }
        } catch (e) {
          this.$message.error(this.pendingEnable ? '启用失败' : '禁用失败')
        } finally {
          this.statusSubmitting = false
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.member-info-container {
  label {
    font-weight: normal;
  }
}
.member-row-status {
  display: flex;
  align-items: center;
  justify-content: center;
}
.history-btn {
  margin-left: 8px;
  padding: 0 4px;
}
</style>
